var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgListBullet = function SvgListBullet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.59359 5.856C7.59359 9.7824 6.87836 12 5.99992 12C5.12149 12 4.40625 9.7776 4.40625 5.856C4.40625 1.9344 5.12149 0 5.99992 0C6.87836 0 7.59359 1.9344 7.59359 5.856Z",
    fill: "#8700DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14425 7.59345C2.21769 7.59345 0 6.87825 0 5.99985C0 5.12145 2.22249 4.40625 6.14425 4.40625C10.0708 4.40625 12.0005 5.12145 12.0005 5.99985C12.0005 6.88305 10.0708 7.59345 6.14425 7.59345Z",
    fill: "#8700DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21972 7.02698C4.4452 9.80138 2.37152 10.867 1.74749 10.2478C1.12347 9.62378 2.19392 7.55018 4.96843 4.77578C7.74295 2.00138 9.61502 1.13738 10.2342 1.76138C10.8583 2.38058 9.99423 4.24778 7.21972 7.02698Z",
    fill: "#8700DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96862 7.22827C2.19411 4.45387 1.12846 2.38028 1.74768 1.75628C2.37171 1.13228 4.4454 2.20267 7.21991 4.97707C9.99443 7.75147 10.8585 9.62347 10.2344 10.2427C9.61041 10.8667 7.74314 10.0027 4.96862 7.22827Z",
    fill: "#8700DC"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgListBullet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ListBullet.7220da97.svg";
export { ForwardRef as ReactComponent };